import { CommonModule } from '@angular/common';
import { Inject, InjectionToken, ModuleWithProviders, NgModule, Optional } from '@angular/core';
import { Icon } from './build';
import { IconRegistryService } from './icon-registry.service';
import { IconComponent } from './icon/icon.component';

@NgModule({
  declarations: [IconComponent],
  imports: [CommonModule],
  exports: [IconComponent]
})
export class IconsModule {
  private static ICONS = new InjectionToken('ICONS');

  constructor(iconRegistryService: IconRegistryService, @Inject(IconsModule.ICONS) @Optional() icons: Icon[][] | null) {
    iconRegistryService.register(icons);
  }

  static withIcons(...icons: Icon[]): ModuleWithProviders<IconsModule> {
    return {
      ngModule: IconsModule,
      providers: [{ provide: IconsModule.ICONS, useValue: icons, multi: true }]
    };
  }
}
